// POST /moods · GET /moods/month · GET /moods/week
import { z } from 'zod'
import { moodValueSchema } from '../enums.js'
import { idSchema, isoDateSchema, yearMonthSchema } from './common.js'

export const moodDtoSchema = z.object({
  user_id: idSchema,
  date: isoDateSchema,
  value: moodValueSchema,
})
export type MoodDto = z.infer<typeof moodDtoSchema>

// POST /moods — отметка состояния дня.
export const createMoodRequestSchema = z.object({
  value: moodValueSchema,
})
export type CreateMoodRequest = z.infer<typeof createMoodRequestSchema>
export const createMoodResponseSchema = moodDtoSchema
export type CreateMoodResponse = z.infer<typeof createMoodResponseSchema>

// День месяца: отметки нет — value: null (карточка недели/месяца рисует пропуск пунктиром).
export const moodDaySchema = z.object({
  date: isoDateSchema,
  value: moodValueSchema.nullable(),
})
export type MoodDay = z.infer<typeof moodDaySchema>

// GET /moods/month?month=YYYY-MM
export const moodMonthQuerySchema = z.object({
  month: yearMonthSchema,
})
export type MoodMonthQuery = z.infer<typeof moodMonthQuerySchema>
export const moodMonthResponseSchema = z.object({
  month: yearMonthSchema,
  days: z.array(moodDaySchema),
})
export type MoodMonthResponse = z.infer<typeof moodMonthResponseSchema>

// GET /moods/week?user_id — «её неделя» на шите узла / экране человека. user_id опущен —
// берётся своя неделя (для чужой требуется активная связь, это проверяет бэкенд).
export const moodWeekQuerySchema = z.object({
  user_id: idSchema.optional(),
})
export type MoodWeekQuery = z.infer<typeof moodWeekQuerySchema>
export const moodWeekResponseSchema = z.object({
  user_id: idSchema,
  days: z.array(moodDaySchema),
})
export type MoodWeekResponse = z.infer<typeof moodWeekResponseSchema>
